import {Component} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Keyboard, LoadingController} from "ionic-angular";
import { Base64Util } from "../../util/base64Util";
@Component({
  templateUrl: 'service.html',
  selector: 'recharge-website-page'
})
export class ServicePage {
  title: string = "Hỗ trợ trực tuyến";
  trustedUrl: any;
  loading:any;
  constructor(private keyboard: Keyboard,private sanitizer: DomSanitizer,public loadingCtrl: LoadingController) {
    //let url = localStorage.getItem("onlineURL");
    let un = localStorage.getItem("u");
    if (un) {
      un = new Base64Util().decode(localStorage.getItem("u"));
    } else {
      un="";
    }
    let url = "https://secure.livechatinc.com/licence/16548507/open_chat.cgi?name=" +un;
    this.loading = loadingCtrl.create({
      content: ''
    });
    this.loading.present();
    this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  webLoad(){
    this.loading.dismiss().catch(() => {});
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/service/service.ts